import ReactPatternLock from "./components/PatternLock";
export default ReactPatternLock;
